import Index from './index.vue'
import List from './components/List.vue'
import Create from './components/Create.vue'
import Edit from './components/Edit.vue'


export default [
  {
    path: 'language',
    name: 'language',
    component: Index,
    title: 'Language',
    redirect: { name: 'language-list' },
    children: [
      {
        path: 'list',
        name: 'language-list',
        component: List,
      },
      {
        path: 'create',
        name: 'language-create',
        component: Create,
      },
      {
        path: 'edit/:id',
        name: 'language-edit',
        component: Edit,
      },
      // {
      //   path: 'profile/:id',
      //   name: "user-profile",
      //   component: Profile
      // }
    ],
    
  },
]
